export default __webpack_public_path__ + "static/media/ranger_white_icon.d399140b.png";